// extracted by mini-css-extract-plugin
export default {"card":"Cards_card__S96K6"};